// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qQhmg","footer":"styles_footer__zE2sQ"};